import React, {useState, useEffect} from 'react'
import {api} from './api'
import {prettyDate, fmt} from './lib'

export default function History() {
  const [data, setData] = useState(null) // {goal, days}
  const [err, setErr] = useState('')

  useEffect(() => {
    api.history(30).then(setData).catch(e => setErr(e.message))
  }, [])

  const days = data?.days || []
  const goal = data?.goal?.calories || 0
  const avg = days.length ? Math.round(days.reduce((s, d) => s + d.calories, 0) / days.length) : 0
  const max = Math.max(goal, ...days.map(d => d.calories), 1)

  return (
    <div className="page">
      <header className="page-head">
        <h1>History</h1>
        <span className="page-sub">last {days.length} days</span>
      </header>

      {days.length === 0 && !err && <div className="empty">No history yet.<br />Log some food and it shows up here.</div>}
      {err && <div className="empty">{err}</div>}

      {days.length > 0 && (
        <div className="stat-row">
          <Stat label="Daily average" value={fmt(avg)} unit="kcal" />
          <Stat label="Days logged" value={fmt(days.length)} unit="" />
        </div>
      )}

      <div className="hist">
        {days.map(d => {
          const pct = Math.min((d.calories / max) * 100, 100)
          const over = goal > 0 && d.calories > goal
          return (
            <div key={d.date} className="hist-row">
              <div className="hist-date">{prettyDate(d.date)}</div>
              <div className="hist-bar-track">
                <div className="hist-bar" style={{width: pct + '%', background: over ? 'var(--danger)' : 'var(--accent)'}} />
                {goal > 0 && (
                  <div className="hist-goal" style={{left: Math.min((goal / max) * 100, 100) + '%'}} title="goal" />
                )}
              </div>
              <div className="hist-cal">{fmt(d.calories)}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

function Stat({label, value, unit}) {
  return (
    <div className="stat">
      <div className="stat-value">
        {value} {unit && <span className="stat-unit">{unit}</span>}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  )
}
